module.exports = __webpack_public_path__ + "img/logo-icon-app.529a8d0c.png";